import { isInvoicingOrgSession, type SessionContextType } from '../contexts/SessionContext';
import { isInternalStaff } from './internalAccess';

/**
 * Internal Yaxle admin: an admin employee account, or a signed-in org admin on a company-domain
 * account. Employees with custom access are not admins. Display gate only — the API still
 * requires `user.admin` on the write.
 */
export const isYaxleInternalAdmin = (session: SessionContextType | undefined): boolean =>
    session?.isAuthenticated === true && session.isAdmin === true && isInternalStaff(session);

/**
 * Who can add a shop location by hand (POST /settings/location/add), with no platform
 * sync. Internal staff on any org, plus invoicing-org admins who already
 * self-serve locations.
 */
export const canAddOrganizationLocation = (session: SessionContextType | undefined): boolean =>
    isYaxleInternalAdmin(session) ||
    (isInvoicingOrgSession(session) && session?.isAdmin === true);
